import { createContext } from 'react';

/**
 * Enum representing the types of modals that can be opened.
 * Add modals here if you need them globally accessible.
 */
export enum ModalType {
  UPGRADE = 'UPGRADE',
}

/**
 * Current modal state
 */
type CurrentModalState = {
  type: ModalType;
  trackingSource?: string;
};

/**
 * Context value type for managing global modals.
 */
type GlobalModalContext = {
  currentModal: ModalType | null;
  openModal: (props: CurrentModalState) => void;
  closeModal: () => void;
  registerModals: (registeredModals: ModalType[]) => void;
};

/**
 * Default context values.
 */
export const GlobalModalContext = createContext<GlobalModalContext>({
  currentModal: null,
  openModal: () => {
    // noop
  },
  registerModals: () => {
    // noop
  },
  closeModal: () => {
    // noop
  },
});
